import React, { useState, useCallback, useEffect } from "react";
import { NumericFormat, PatternFormat } from "react-number-format";
import {
  accountListSelector,
  selectedAccountSelector,
} from "../store/selectors/app.selector";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Divider, Modal, Select, Switch } from "antd";
import { CONFIG } from "../environment";
import { setSelectedAccount } from "../store/actions/app.action";
import {
  accNoFormat,
  amountFormat,
  amountNoCurrencyFormat,
  maskAccountNumber,
} from "../services/common.service";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";

export default function AccountCard({ currencyFilter = false }) {
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const { t } = useTranslation();
  const accountList = useSelector(accountListSelector);
  const dispatch = useDispatch();
  const selectedAccount = useSelector(selectedAccountSelector);
  const [visible, setVisible] = useState(false);
  const [accno, setAccNo] = useState(selectedAccount?.accountNo);
  const [showBalance, setShowBalance] = useState(false);

  useEffect(() => {
    if (accountList.length > 0) {
      setFilteredAccounts([...accountList]);
    }
    if (currencyFilter === true) {
      const fiteredAcc = accountList.filter(
        (ele) => ele.accountCurrency === CONFIG.CURRENCY
      );
      setFilteredAccounts(fiteredAcc);
      dispatch(setSelectedAccount(fiteredAcc.length > 0 ? fiteredAcc[0] : {}));
    } else {
      setFilteredAccounts([...accountList]);
    }
  }, [currencyFilter, accountList]);

  const handleChangeAccount = useCallback(
    (value) => {
      const selectedAccDetails = accountList.find(
        (ele) => ele.accountNo === value.accountNo
      );
      dispatch(setSelectedAccount(selectedAccDetails));
      setAccNo(value.accountNo);
    },
    [accountList]
  );
  console.log("++>>selectedAccount", selectedAccount);

  return (
    <div>
      {
        <div className="account-card-selection">
          <div className="accont-selected-card mx-2">
            <div className="d-flex justify-content-end show-balance">
              {!showBalance ? (
                <span className="mt-1">Show Balance</span>
              ) : (
                <span className="mt-1">Hide Balance</span>
              )}{" "}
              <Switch
                onChange={() => setShowBalance(!showBalance)}
                className="custom-switch"
              />
            </div>
            <div className="balance d-flex ">
              {showBalance ? (
                <>
                  <span>{selectedAccount?.accountCurrency}</span>

                  <span style={{ marginLeft: 10 }}>
                    {amountNoCurrencyFormat(selectedAccount?.avlBalance)}
                  </span>
                </>
              ) : (
                <>
                  <span className="">{selectedAccount?.accountCurrency}</span>

                  <span
                    style={{
                      letterSpacing: 4,
                      fontSize: "20px",
                      marginLeft: 10,
                    }}
                  >
                    ********
                  </span>
                </>
              )}
            </div>
            <div className="d-flex align-items-center mt-2">
              <span style={{ letterSpacing: 2 }}>
                {maskAccountNumber(selectedAccount?.accountNo)}
              </span>
              <span className="status-btn">
                {selectedAccount?.status || "ACTIVE"}
              </span>
            </div>

            <div className="mt-4 d-flex justify-content-between align-items-center">
              <span style={{ fontSize: "14px" }}>
                {selectedAccount?.accountName}
              </span>
              <div>
                <Button
                  onClick={() => setVisible(true)}
                  className="view-btn"
                  size="small"
                >
                  View Account
                </Button>
              </div>
            </div>
          </div>
        </div>
      }

      {filteredAccounts?.length > 1 &&
        (currencyFilter === false ? (
          <Card className="custom-card-style mt-3">
            <div className="account-lists">
              <label>
                {t("common.account_list", {
                  defaultValue: "ACCOUNT LIST",
                })}
              </label>
              <div>
                {filteredAccounts.map(
                  (account, index) =>
                    account?.accountNo !== selectedAccount?.accountNo && (
                      <Card key={index} className={`account-card`}>
                        <div
                          className="accounts-detail"
                          onClick={() => handleChangeAccount(account)}
                        >
                          <div className="d-flex justify-content-between">
                            <div>
                              <label className="balance-heading">
                                {t("common.account_no_lbl", {
                                  defaultValue: "Account Number",
                                })}
                              </label>
                              <div className="account-balance">
                                {account?.accountNo}
                              </div>
                            </div>
                            <div align="right">
                              <label className="balance-heading">Balance</label>
                              <div className="account-balance">
                                <span style={{ marginRight: 5 }}>
                                  {account?.accountCurrency}
                                </span>
                                ********
                              </div>
                            </div>
                          </div>
                        </div>
                      </Card>
                    )
                )}
              </div>
            </div>
          </Card>
        ) : (
          <Card className="custom-card-style mt-3">
            <div className="account-lists">
              <label>ACCOUNT LIST</label>
              <div>
                {filteredAccounts
                  .filter((ele) => ele.accountCurrency === CONFIG.CURRENCY)
                  .map(
                    (account, index) =>
                      account?.accountNo !== selectedAccount?.accountNo && (
                        <Card key={index} className={`account-card`}>
                          <div
                            className="accounts-detail"
                            onClick={() => handleChangeAccount(account)}
                          >
                            <div className="d-flex justify-content-between">
                              <div>
                                <label className="balance-heading">
                                  {t("common.account_no_lbl", {
                                    defaultValue: "Account Number",
                                  })}
                                </label>
                                <div className="account-balance">
                                  {account?.accountNo}
                                </div>
                              </div>
                              <div align="right">
                                <label className="balance-heading">
                                  {t(
                                    "pages.my_accounts.common_my_accounts.balance",
                                    {
                                      defaultValue: "Balance",
                                    }
                                  )}
                                </label>
                                <div className="account-balance">
                                  <span style={{ marginRight: 5 }}>
                                    {account?.accountCurrency}
                                  </span>
                                  <NumericFormat
                                    value={account?.avlBalance}
                                    displayType={"text"}
                                    autoComplete="off"
                                    thousandSeparator={true}
                                    prefix={""}
                                    fixedDecimalScale={true}
                                    decimalScale={2}
                                    allowEmptyFormatting
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Card>
                      )
                  )}
              </div>
            </div>
          </Card>
        ))}

      <Modal
        open={visible}
        footer={null}
        width={450}
        mask={true}
        centered
        onCancel={() => {
          setVisible(false);
        }}
      >
        <div className="confirm-details">
          <label>
            {t("common.view_account", {
              defaultValue: "View Account Details",
            })}
          </label>
          <span className="confirm-title">{selectedAccount?.accountNo}</span>
          <div className="row">
            <div className="col-12 d-flex justify-content-between ">
              <label className="col-6">
                {t("pages.service_request.common_service.account_type", {
                  defaultValue: "Account Type",
                })}
              </label>
              <span className="col-6 ">
                {selectedAccount.accountType === "SA" && "Saving Account"}
                {selectedAccount.accountType === "CA" &&
                  t("pages.portfolio.current_acc", {
                    defaultValue: "Current Account",
                  })}
                {selectedAccount.accountType === "ODA" && "Over Draft Account"}
                {selectedAccount.accountType === "FD" && "Term Deposit Account"}
                {selectedAccount.accountType === "LA" && "Facility Account"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {t("pages.my_accounts.common_my_accounts.account_name", {
                  defaultValue: "Account Name",
                })}
              </label>
              <span className="col-6 ">
                {selectedAccount?.accountName || "-"}
              </span>
            </div>

            {/* <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">{t("common.account_class", {
                  defaultValue: "Account Class",
                })}</label>
              <span className="col-6 ">
                {selectedAccount?.accountClass || "-"}
              </span>
            </div> */}

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {t("pages.password_change.customer_id", {
                  defaultValue: "Customer ID",
                })}
              </label>
              <span className="col-6">
                {selectedAccount?.customerId || "-"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {t("pages.locateUs.branch", {
                  defaultValue: "Branch",
                })}
              </label>
              <span className="col-6">
                {/* {selectedAccount?.branchId || "-"} &nbsp; */}
                {selectedAccount?.branchName}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">Sort Code</label>
              <span className="col-6">{selectedAccount?.sortCode || "-"}</span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {t("pages.standing_instruction.swift_code", {
                  defaultValue: "Swift Code",
                })}
              </label>
              <span className="col-6">{selectedAccount?.swiftCode || "-"}</span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {t("common.currency", {
                  defaultValue: "Currency",
                })}
              </label>
              <span className="col-6">
                {selectedAccount?.accountCurrency || "-"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {t("pages.my_accounts.casa.available_balance", {
                  defaultValue: "Available Balance",
                })}
              </label>
              <span className="col-6">
                {amountNoCurrencyFormat(selectedAccount?.avlBalance) || "-"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {t("pages.dashboard.current_balance", {
                  defaultValue: "Current Balance",
                })}
              </label>
              <span className="col-6">
                {amountNoCurrencyFormat(selectedAccount?.currentBalance) || "-"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">Account Open Date</label>
              <span className="col-6">
                {moment(selectedAccount?.acctOpDt).format("DD.MM.YYYY") || "-"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">Account Description</label>
              <span className="col-6">
                {selectedAccount?.accountClassDesc || "-"}
              </span>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
